const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent);

export default isMobileDevice;
